export default {"src":"/_next/static/media/headphone.e041582a.svg","height":683,"width":683,"blurWidth":0,"blurHeight":0};